import axios from "axios";
import router from "@/router";
import alert from "@/lang/AlertMessages.js";

const panelXios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

axios.defaults.headers.common["Accept-Language"] = "fa";
panelXios.defaults.headers.common["Content-Type"] = "application/json";
panelXios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.panelToken;

export default {
  // Members Authentications -------------------------------------------------------
  login({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/LoginMember", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("authUser", res.data);
        localStorage.setItem("panelToken", res.data.access_token);
        panelXios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.access_token;
        router.push({ name: "PanelDashboard" });
        commit("setSuccess", alert.success.login, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  sendRegisterCode({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/Register", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.codeSent,
            redirect: false,
          },
          { root: true }
        );
        commit("setRegisterCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  submitRegisterCode({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/Authentication", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setRegisterAuth", res.data.data);
        localStorage.setItem("panelToken", res.data.data.access_token);
        panelXios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.data.access_token;
        commit("setSuccess", alert.success.register, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  completeRegisteration({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("Account/CompleteRegistration", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        commit("authUser", res.data.data);
        const payload = {
          access_token: null,
          isNew: false,
        };
        commit("setRegisterAuth", payload);
        localStorage.setItem("panelToken", res.data.data.access_token);
        panelXios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.data.access_token;
        commit("setSuccess", alert.success.completeRegister, { root: true });
        router.push({ name: "UserProfile" });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  forgotPassword({ commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/ForgotPassword", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        commit("setSuccess", alert.success.codeSent, { root: true });
        commit("setForgotCheck", true);
        setTimeout(() => {
          commit("setForgotCheck", false);
        }, 800);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          if (
            error.response.data.message &&
            error.response.data.message == "یافت نشد"
          ) {
            commit("setError", alert.error.mobileNotFound, { root: true });
          } else if (
            error.response.data.message &&
            error.response.data.message != "یافت نشد"
          ) {
            const errMsg =
              error.response.data.message + " ثانیه دیگر مجدد امتحان کنید";
            commit("setError", errMsg, { root: true });
          } else {
            commit("setError", alert.error.server, { root: true });
          }
        } else {
          commit("setError", alert.error.server, { root: true });
        }
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  resetPassword({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/ResetPassword", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changePassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  logout({ commit }) {
    localStorage.removeItem("panelToken");
    panelXios.defaults.headers.common["Authorization"] = "";
    commit("clearAuth");
    router.push({ name: "Login" });
  },

  // Profile Actions -------------------------------------------------------------------------------
  getProfile({ dispatch, commit }) {
    panelXios
      .get("member/Profile")
      .then((res) => {
        commit("setProfile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editProfile({ dispatch }, data) {
    panelXios
      .put("member/Profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editPassword({ dispatch }, data) {
    panelXios
      .put("member/Profile/changePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editAvatar({ dispatch }, data) {
    panelXios
      .post("member/Profile", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteAvatar({ dispatch }) {
    panelXios
      .delete("member/Profile")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Address List ----------------------------------------------------------------
  getAddress({ dispatch, commit }) {
    panelXios
      .get("member/Address")
      .then((res) => {
        commit("setAddress", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addAddress({ dispatch }, data) {
    panelXios
      .post("member/Address", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.addUser,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  editAddress({ dispatch }, data) {
    panelXios
      .put("member/Address/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.editUser,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  deleteAddress({ dispatch }, data) {
    panelXios
      .delete("member/Address/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // change password ----------------------------------------------------------------
  editProfilePassword({ dispatch }, data) {
    panelXios
      .put("member/Profile/changePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  profileAvatar({ dispatch }, data) {
    panelXios
      .post("member/Profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.add,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Factor Actions ........................................................................
  getFactors({ dispatch, commit }) {
    panelXios
      .get("member/Factor")
      .then((res) => {
        commit("setFactors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFactorById({ dispatch, commit }, data) {
    panelXios
      .get("member/Factor/" + data)
      .then((res) => {
        commit("setFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Cart Actions --------------------------------------------------------------------------
  // getCart({ dispatch, commit }) {
  //   axios
  //     .get("Panel/FactorDetail")
  //     .then((res) => {
  //       commit("setCart", res.data.data);
  //     })
  //     .catch((error) => {
  //       dispatch("errorGETHandler", error, { root: true });
  //     });
  // },

  addToCart({ dispatch }, data) {
    panelXios
      .post("Member/FactorDetail", data, {
        withCredentials: true,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.addToCart,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Factor Detail Actions..........................................................

  getFactorDetail({ dispatch, commit }) {
    panelXios
      .get("member/FactorDetail")
      .then((res) => {
        commit("setFactorDetail", res.data.data);
      })
      .catch((error) => {
        commit("setFactorDetail", {});
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Favorites Actions ---------------------------------------------------------------
  getFavorites({ dispatch, commit }) {
    panelXios
      .get("member/Favorite")
      .then((res) => {
        commit("setFavorites", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getFavorite({ dispatch, commit }, data) {
    panelXios
      .get("member/Favorite/" + data)
      .then((res) => {
        commit("setFavorite", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  changeFavorite({ dispatch }, data) {
    panelXios
      .post("member/Favorite/Favorite", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // AvailableReturnProducts Actions ---------------------------------------------------------------
  getAvailableReturnProducts({ dispatch, commit }) {
    panelXios
      .get("Member/AvailableReturnProducts")
      .then((res) => {
        commit("setAvailableReturnProducts", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Returns Actions ---------------------------------------------------------------
  getReturns({ dispatch, commit }) {
    panelXios
      .get("Member/Return")
      .then((res) => {
        commit("setReturns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReturn({ dispatch }, data) {
    panelXios
      .post("Member/Return", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editReturn({ dispatch }, data) {
    panelXios
      .put("Member/Return/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteReturn({ dispatch }, data) {
    panelXios
      .delete("Member/return/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Tickets Actions ---------------------------------------------------------------
  getTickets({ dispatch, commit }, data) {
    panelXios
      .get("Member/Ticket?" + data)
      .then((res) => {
        commit("setTickets", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editFactorDetail({ dispatch }, data) {
    panelXios
      .put("member/FactorDetail/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteFactorDetail({ dispatch }, data) {
    panelXios
      .delete("member/FactorDetail/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getPayBanks({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/PayBanks")
      .then((res) => {
        commit("setPayBanks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getTicket({ dispatch, commit }, data) {
    panelXios
      .get("Member/Ticket/" + data)
      .then((res) => {
        commit("setTicket", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addAnswer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("Member/Ticket", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editTicket({ dispatch, commit }, data) {
    axios
      .put("Member/Ticket/" + data.id, data.value, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  deleteTicket({ dispatch }, data) {
    panelXios
      .delete("Member/Ticket/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // addInvoice({ dispatch }, data) {
  //   axios
  //     .post("member/Invoice", data)
  //     .then((res) => {
  //       dispatch(
  //         "successPOSTHandlerSimple",
  //         {
  //           server: res,
  //           message: alert.success.addOrder,
  //         },
  //         { root: true }
  //       );
  //     })
  //     .catch((error) => {
  //       dispatch("errorPOSTHandler", error, { root: true });
  //     });
  // },

  addInvoice({ dispatch }, data) {
    panelXios
      .post("member/Invoice", data, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandlerSimple",
          {
            server: res,
            message: alert.success.addOrder,
          },
          { root: true }
        );
        window.open(res.data.data.url);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getFestivalDiscount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .get("member/FestivalDiscount?" + data)
      .then((res) => {
        commit("setFestivalDiscount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

    verifyPayment({ dispatch, commit }, data) {
        panelXios
            .get("member/Invoice?factorid=" + data.factorId + "&Authority=" + data.authority + "&Status=" + data.status)
            .then((res) => {
                commit("setPaymentResult", res.data.data);
            })
            .catch((error) => {
                dispatch("errorPOSTHandler", error, { root: true });
            });
    },

  verifyWalletPayment({ dispatch, commit }, data) {
    panelXios
      .post("member/Wallet/VerifyPayment", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setPaymentResult", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  getWallet({ dispatch, commit }) {
    panelXios
      .get("Member/wallet")
      .then((res) => {
        commit("setWallet", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFestivalDiscount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .put("Member/FactorDetail/UpdateFactorPriceByFestivalCode/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.discountCode,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
